import { render, staticRenderFns } from "./ProductListPagination.vue?vue&type=template&id=44c31d3a"
import script from "./ProductListPagination.vue?vue&type=script&lang=js"
export * from "./ProductListPagination.vue?vue&type=script&lang=js"
import style0 from "./ProductListPagination.vue?vue&type=style&index=0&id=44c31d3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports